import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// axios
import http from '@/utils/http';
Vue.prototype.$http = http;

import ElementUI from 'element-ui';
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/styles/app.less';
import '@/assets/styles/font/iconfont.css';

import lineClamp from 'vue-line-clamp';
Vue.use(lineClamp);
import { List } from 'vant';
Vue.use(List);

Vue.config.productionTip = false;
Vue.prototype.$eventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
